import React from 'react'
import { Modal,ModalBody,ModalFooter,ModalHeader,ModalContent,Button } from '@nextui-org/react';

const DeleteModal = ({ isOpen, onClose, onConfirm }) => {
    return (
        <>
      <Modal size="sm" isOpen={isOpen} onClose={onClose} className="p-3" placement="center">
        <ModalContent>
          <ModalHeader>Are you sure?</ModalHeader>
          <ModalBody>
            <p className="text-center">Are you sure you want to Delete?</p>
          </ModalBody>
          <ModalFooter className="flex justify-center gap-4">
        
            <Button color="primary" onPress={onConfirm}>
              Yes
            </Button>
            <Button color="danger" variant="light" onPress={onClose}>
              No
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
        </>
    );
  };
  

export default  DeleteModal
